
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { RetentionPolicyForm, RetentionPolicyFormValues } from './RetentionPolicyForm';
import { ContextualHelp } from '../ContextualHelp';

interface AddPolicyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (values: RetentionPolicyFormValues) => Promise<void>;
  isSubmitting: boolean;
}

export function AddPolicyDialog({ 
  open, 
  onOpenChange, 
  onSubmit,
  isSubmitting 
}: AddPolicyDialogProps) {
  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add Policy
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            Create Retention Policy
            <ContextualHelp topic="retention-policy" />
          </DialogTitle>
          <DialogDescription>
            Define how long records should be retained before archiving
          </DialogDescription>
        </DialogHeader>
        
        <RetentionPolicyForm 
          onSubmit={onSubmit} 
          onCancel={handleCancel} 
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
}
